export function SectionHeader(props) {
    return (
        <h1 className='text-left w-full text-xl pb-3 mb-5 mt-8 border-b border-black'>{props.title}</h1>
    )
}

export function TourSectionHeader(props) {

    return (
        <div>
            <div className='relative h-20 w-2/3 flex justify-start items-end bg-gradient-to-bl from-slate-200 via-slate-200  to-white'>
                <h1 className='text-4xl font-cursive pl-8'>{props.title}</h1>
            </div>
            <div className='w-2/3 bg-gradient-to-r from-red-700 via-red-600 to-slate-200 h-1 mb-4'></div>
        </ div>
    )
}
